import React from "react";
import ReactDOM from "react-dom/client";
import { Global, ThemeProvider } from "@emotion/react";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "config/validateEnv";
import { globalStyles, theme } from "assets/theme";
import { HelmetProvider } from "react-helmet-async";
import { PostHogProvider } from "posthog-js/react";
import { client } from "apollo";
import { ApolloProvider } from "@apollo/client";
import { UserContextProvider } from "context";
import ReactGA from "react-ga4";
import "./index.css";
import { config } from "config";
// Google analytics
ReactGA.initialize(process.env.REACT_APP_GOOGLE_MEASUREMENT_ID!);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: process.env.NODE_ENV,
  });
}

// manually send errors to Sentry

const options = {
  api_host: config.posthog.host,
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <PostHogProvider apiKey={config.posthog.key} options={options}>
          <UserContextProvider>
            <ThemeProvider theme={theme}>
              <HelmetProvider>
                <Global styles={globalStyles} />
                <App />
              </HelmetProvider>
            </ThemeProvider>
          </UserContextProvider>
        </PostHogProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
